"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const UndergroundToken_vue_1 = __importDefault(require("./UndergroundToken.vue"));
exports.default = (0, vue_1.defineComponent)({
    name: 'UndergroundTokens',
    components: {
        UndergroundToken: UndergroundToken_vue_1.default,
    },
    props: {
        underworldData: {
            type: Object,
            required: true,
        },
    },
    methods: {
        border(token) {
            return token.active ? 'underground-token-border' : '';
        },
    },
});
